/**
 * @param {string} inputUrl - The URL to check
 * @returns {boolean} - True if the URL is allowed, false otherwise
 */
export function isAllowedDomain (inputUrl) {
  const allowedDomains = [
    'localhost',
    //
    'gridunity.com',
    'gridunity.net',
    //
    'caiso.com',
    'entergy-interconnection.com',
    'hawaiianelectric.com',
    'hawaiianelectric.net',
    'icon.southerncompany.com',
    'sce.com',
    'spp.org',
    'yourprojects-pge.com',
  ]

  try {
    // Check if the URL is valid
    const isRelativePath = !/^[a-zA-Z][a-zA-Z\d+\-.]*:/.test(inputUrl)
    const parsedUrl = new URL(inputUrl, isRelativePath ? window.location.origin : undefined)
    const hostname = parsedUrl.hostname

    return allowedDomains.some(domain => {
      return (
        hostname === domain
        || hostname.endsWith(`.${domain}`)
      )
    })
  } catch {
    // If the URL is invalid, return false
    return false
  }
}
